import {providerChannels} from "@hosttools/core/constant";
import type {Price as PriceModel} from "@hosttools/core/generated/models";
import {formatPrice} from "@hosttools/core/shared/utils/utils.price";

import type {ListingChannel} from "./listing";

export type PriceRaw = MongooseModel2Client<PriceModel>;

export type Price = PriceRaw;

export type PriceChannelCustom<T = Price> = {
    [P in keyof T]: P extends ListingChannel
        ? T[P] & {
              priceFormatted: string;
              currentPriceFormatted: string;
              priceOverrideFormatted?: string;
          }
        : T[P];
};

export const toPriceStringOnCalendar = (currencySymbol: string, price?: number) =>
    typeof price !== "undefined" ? formatPrice(price, currencySymbol) : "-";

export function formatChannelPrices(price: Price, currencySymbol: string) {
    return providerChannels.reduce(
        (result, channel) => {
            const priceChannel = price[channel];
            if (priceChannel) {
                const priceFormatted = toPriceStringOnCalendar(currencySymbol, priceChannel.price);
                const currentPriceFormatted = toPriceStringOnCalendar(
                    currencySymbol,
                    priceChannel.currentPrice
                );
                const priceOverrideFormatted = toPriceStringOnCalendar(
                    currencySymbol,
                    priceChannel.priceOverride
                );

                result[channel] = {
                    ...priceChannel,
                    priceFormatted,
                    currentPriceFormatted,
                    priceOverrideFormatted
                };
            }

            return result;
        },
        {...price} as PriceChannelCustom
    );
}
